// Angular modules.
import { Pipe, PipeTransform } from '@angular/core';
import { IAvailability } from 'app/interfaces/availability.interface';
// Zenklub services.
import { DateTimeService } from 'app/services/datetime.service';
import { DateTime } from 'luxon';

import { UserService } from '../../services/user.service';

@Pipe({ name: 'infullDate' })
export class InFullDatePipe implements PipeTransform {
	constructor(
		protected dateTime: DateTimeService,
		protected user: UserService
	) {}
	transform(availability: IAvailability, prop: string): string {
		const userLanguage = this.user.getUserLocalPreferences().Language;
		const dateTime = DateTime.fromISO(availability[prop], {
			zone: availability.timezone,
		}).setLocale(userLanguage);

		return dateTime.toLocaleString(DateTime.DATE_HUGE);
	}
}

@Pipe({ name: 'fullDate' })
export class FullDatePipe implements PipeTransform {
	constructor(protected dateTime: DateTimeService) {}
	transform(value: string): string {
		return this.dateTime.getInFullDate(new Date(value));
	}
}
